/**
 * @generated SignedSource<<47a7b79093d995f3b914070a067d0728>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ThumbnailOption_node$data = {
  readonly __typename?: string;
  readonly canUpdateThumbnail?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly thumbnail?: {
    readonly url: URIString;
  } | null;
  readonly " $fragmentType": "ThumbnailOption_node";
};
export type ThumbnailOption_node$key = {
  readonly " $data"?: ThumbnailOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThumbnailOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ThumbnailOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "canUpdateThumbnail",
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canRename",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Folder",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "canUpdateThumbnail",
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdate",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Vault",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Thumbnail",
          "kind": "LinkedField",
          "name": "thumbnail",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "HasThumbnailInterface",
      "abstractKey": "__isHasThumbnailInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "9715fc70d0eb1a10304ede08903ca576";

export default node;
